export default {
    pageType: null,
    isMember: null,
    gtm: {
        start: "",
        uniqueEventId: "",
        element: "",
        elementClasses: "",
        elementId: "",
        elementTarget: "",
        elementUrl: ""
    },
    event: null,
    bannerName: null,
    bannerID: null,
    slideName: null,
    slideID: null,
    advertStart: null,
    advertEnd: null,
    imgTitle: null,
    imgAlt: null,
    clickURL: null,
    timeStamp: null,
    IPaddress: null,
    seller: null,
    orderNumber: null,
    auction_event_id: null,
    blog_id: null,
    item_id: null,
    landing_page_id: null,
    seller_id: null,
    price: null,
    manufacturer_name: null,
    model: null,
    headline: null,
    adNo: null,
    name: null,
    id: null,
    brand: null,
    variant: null,
    list: null,
    position: null
}